import useFetchList from 'actions/useFetchList';
import contentKeys from './queryKeys';
export default function useFetchMyFeaturedContent() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$limit = _ref.limit,
    limit = _ref$limit === void 0 ? 10 : _ref$limit,
    _ref$offset = _ref.offset,
    offset = _ref$offset === void 0 ? 0 : _ref$offset,
    enabled = _ref.enabled;
  return useFetchList('me/content/featured', {
    limit: limit,
    offset: offset,
    format: 'list'
  }, {
    queryKey: contentKeys.myFeaturedContent(limit, offset),
    staleTime: 5 * 60 * 1000,
    enabled: enabled
  });
}